module.exports = __webpack_public_path__ + "static/media/sh.487ef1c8.svg";